// extracted by mini-css-extract-plugin
module.exports = {"container":"_2Ixi8KF5","imageWrapper":"_2R1SrPgO","errorText":"_2Sn9CNI5","subtext":"VgixyTmO","mailLink":"ADWXyBx9"};
    if(module.hot) {
      // 1754514924832
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  